import React, { memo } from 'react'
import capitalize from 'lodash/capitalize'
import AddIcon from 'transfix-icons/build/AddIcon'
import CloseIcon from 'transfix-icons/build/CloseIcon'
import { Button } from 'transfix-ui/components/Button'
import { IStopFormSectionProps } from '../StopFormSection'
import { useStopButtonsStyles } from './useStopButtonsStyles'

export interface IStopButtonsProps
  extends Pick<
    IStopFormSectionProps,
    | 'stopIndex'
    | 'stopType'
    | 'includeAddButton'
    | 'includeDeleteButton'
    | 'onAddStop'
    | 'onDeleteStop'
  > {
  /**
   * @example 'ef6f8870-8676-4b91-95c2-85dd486263f3'
   */
  shipperFacilityUuid: string | undefined
}

const StopButtons = memo<IStopButtonsProps>(
  ({
    includeAddButton,
    includeDeleteButton,
    onAddStop,
    onDeleteStop,
    shipperFacilityUuid,
    stopIndex,
    stopType,
  }) => {
    const classes = useStopButtonsStyles()

    /**
     * Handler for deleting a stop
     */
    const deleteStopHandler = () => {
      if (onDeleteStop) {
        onDeleteStop(stopIndex)
      }
    }

    return (
      <div className={classes.buttons}>
        {!shipperFacilityUuid && (
          <div>
            <a href={`${__ROOT__}/facilities/new`} target='_blank' rel='noreferrer'>
              <Button startIcon={<AddIcon />} variant='text'>
                Add Facility
              </Button>
            </a>
          </div>
        )}
        {shipperFacilityUuid && includeAddButton && (
          <div>
            <Button startIcon={<AddIcon />} variant='text' onClick={onAddStop} data-test='add-stop'>
              Add {capitalize(stopType)} Stop
            </Button>
          </div>
        )}
        {includeDeleteButton && (
          <div>
            <Button
              startIcon={<CloseIcon />}
              variant='text'
              onClick={deleteStopHandler}
              className={classes.deleteButton}
              data-test='delete-stop'>
              Delete {capitalize(stopType)} Stop
            </Button>
          </div>
        )}
      </div>
    )
  }
)

export default StopButtons
